import { render, staticRenderFns } from "./ia-imagem.vue?vue&type=template&id=bb740172&"
import script from "./ia-imagem.vue?vue&type=script&lang=js&"
export * from "./ia-imagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb740172')) {
      api.createRecord('bb740172', component.options)
    } else {
      api.reload('bb740172', component.options)
    }
    module.hot.accept("./ia-imagem.vue?vue&type=template&id=bb740172&", function () {
      api.rerender('bb740172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/ia-imagem.vue"
export default component.exports